import { useState } from 'react'
import type { DocumentResponse } from '../types'
import { downloadDocument } from '../api/documents'
import { Button } from '../components/Button'
import styles from './DocumentCard.module.css'

const DOC_NAMES: Record<string, string> = {
  unifilar: 'Diagrama Unilineal',
  planta_enchufes: 'Plano de Enchufes',
  planta_iluminacion: 'Plano de Iluminación',
  cuadro_cargas: 'Cuadro de Cargas',
  memoria_calculo: 'Memoria de Cálculo',
  simbologia: 'Simbología',
  caratula: 'Carátula',
  formulario_te1: 'Formulario TE1',
  presupuesto: 'Presupuesto de Materiales',
  cert_aislacion: 'Certificado de Aislación',
  informe_tierra: 'Informe Malla a Tierra',
  cert_equipos: 'Certificados de Equipos',
  decl_jurada: 'Declaración Jurada',
}

const TEMPLATE_TYPES = new Set(['cert_aislacion', 'informe_tierra', 'cert_equipos', 'decl_jurada'])

interface DocumentCardProps {
  document: DocumentResponse
  projectId: string
}

function PdfIcon() {
  return (
    <svg className={styles.pdfIcon} viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <rect width="24" height="24" rx="4" fill="#D32F2F" />
      <text x="12" y="16" textAnchor="middle" fill="white" fontSize="9" fontWeight="bold" fontFamily="Arial">PDF</text>
    </svg>
  )
}

export function DocumentCard({ document, projectId }: DocumentCardProps) {
  const [downloading, setDownloading] = useState(false)

  const name = DOC_NAMES[document.type] ?? document.type
  const isTemplate = TEMPLATE_TYPES.has(document.type)

  const handleDownload = async () => {
    setDownloading(true)
    try {
      const blob = await downloadDocument(projectId, document.type)
      const url = URL.createObjectURL(blob)
      const a = window.document.createElement('a')
      a.href = url
      a.download = `${document.type}.pdf`
      a.click()
      URL.revokeObjectURL(url)
    } catch {
      // silently ignore download errors — user can retry
    } finally {
      setDownloading(false)
    }
  }

  return (
    <div className={styles.card}>
      <PdfIcon />
      <div className={styles.info}>
        <div className={styles.nameRow}>
          <span className={styles.name}>{name}</span>
          <span className={`${styles.badge} ${isTemplate ? styles.template : styles.generated}`}>
            {isTemplate ? 'Plantilla' : 'Autogenerado'}
          </span>
        </div>
        {document.generated_at && (
          <span className={styles.date}>
            {new Date(document.generated_at).toLocaleDateString('es-CL', {
              day: 'numeric', month: 'short', year: 'numeric',
            })}
          </span>
        )}
      </div>
      <Button variant="secondary" loading={downloading} onClick={handleDownload}>
        Descargar
      </Button>
    </div>
  )
}
